<template>
  <v-dialog
    :value="value"
    max-width="820"
    scrollable
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <div class="px-4 pt-4 pb-2">
        <div class="text-h6">
          Enviar para a conta master
        </div>
        <div class="text-body-2 text--secondary">
          {{ coverageLabel }}
        </div>
      </div>

      <v-tabs
        v-model="tab"
        grow
      >
        <v-tab>
          Itens
          <v-chip
            x-small
            class="ml-2"
          >
            {{ selectedItems.length }}/{{ items.length }}
          </v-chip>
        </v-tab>
        <v-tab>
          Pagamentos
          <v-chip
            x-small
            class="ml-2"
          >
            {{ allPayments.length }}
          </v-chip>
        </v-tab>
        <v-tab :disabled="!hasLeftover">
          Conta avulsa
          <v-chip
            v-if="hasLeftover"
            x-small
            class="ml-2"
            :color="closeLeftover ? 'success' : undefined"
          >
            {{ closeLeftover ? 'fecha agora' : 'aberta' }}
          </v-chip>
        </v-tab>
      </v-tabs>
      <v-divider />

      <v-card-text
        class="pt-3"
        style="height: 52vh;"
      >
        <v-tabs-items
          v-model="tab"
          touchless
        >
          <v-tab-item>
            <div class="d-flex flex-wrap align-center mb-2">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Buscar item"
                clearable
                outlined
                dense
                hide-details
                style="max-width: 240px;"
                class="mr-2"
              />
              <v-btn
                small
                text
                color="primary"
                @click="applyCoverage"
              >
                Padrão da master
              </v-btn>
              <v-btn
                small
                text
                color="primary"
                @click="selectAll"
              >
                Tudo na master
              </v-btn>
              <v-btn
                small
                text
                color="primary"
                @click="selected = []"
              >
                Limpar
              </v-btn>
            </div>
            <div class="text-caption mb-2">
              Marcados vão para a master. O restante vira uma conta avulsa deste hóspede.
            </div>
            <v-tabs
              v-model="itemsTab"
              dense
              show-arrows
              class="mb-2"
            >
              <v-tab
                v-for="group in visibleGroups"
                :key="group.key"
              >
                {{ group.label }}
                <v-chip
                  x-small
                  class="ml-2"
                  :color="groupState(group).count ? 'primary' : undefined"
                  :dark="!!groupState(group).count"
                >
                  {{ groupState(group).count }}/{{ group.items.length }}
                </v-chip>
              </v-tab>
            </v-tabs>
            <template v-if="currentGroup">
              <div class="d-flex flex-wrap align-center grey lighten-4 px-2 py-1">
                <v-btn
                  small
                  depressed
                  :color="groupState(currentGroup).all ? 'primary' : undefined"
                  class="mr-2"
                  @click="toggleGroup(currentGroup, true)"
                >
                  {{ search ? 'Marcar encontrados' : 'Marcar tudo' }}
                </v-btn>
                <v-btn
                  small
                  depressed
                  :color="!groupState(currentGroup).count ? 'primary' : undefined"
                  class="mr-2"
                  @click="toggleGroup(currentGroup, false)"
                >
                  Nenhum
                </v-btn>
                <span class="text-caption">
                  ou escolha item a item
                  <v-chip
                    v-if="groupState(currentGroup).some"
                    x-small
                    color="primary"
                    class="ml-1"
                  >
                    {{ groupState(currentGroup).count }} escolhidos
                  </v-chip>
                </span>
                <v-spacer />
                <span class="text-body-2">
                  R$ {{ money(groupSelectedTotal(currentGroup)) }}
                  <span class="text--secondary">de R$ {{ money(groupTotal(currentGroup)) }}</span>
                </span>
              </div>
              <div
                v-for="item in currentGroup.visible"
                :key="itemKey(item)"
                class="d-flex align-center px-2 item-row"
              >
                <v-checkbox
                  v-model="selected"
                  :value="itemKey(item)"
                  :label="item.description || currentGroup.label"
                  hide-details
                  dense
                  class="mt-0 pt-0 flex-grow-1"
                />
                <span class="text-caption mx-3">{{ item.pivot.quantity }}x</span>
                <span class="text-body-2">R$ {{ money(item.sale_price * item.pivot.quantity) }}</span>
              </div>
              <div
                v-if="!currentGroup.visible.length"
                class="text-caption pa-2"
              >
                Nenhum item encontrado.
              </div>
            </template>
          </v-tab-item>

          <v-tab-item>
            <v-alert
              v-if="!allPayments.length"
              dense
              text
              type="info"
              class="mb-0"
            >
              Nenhum pagamento lançado neste quarto. Se o hóspede já pagou algo (adiantamento ou valor digitado na tela
              de checkout), ele aparece aqui para você escolher se fica na master ou na avulsa.
            </v-alert>
            <template v-else>
              <div class="text-caption mb-1">
                Escolha onde cada pagamento já lançado será usado.
                <span v-if="!hasLeftover">
                  Todos os itens vão para a master, então os pagamentos ficam nela.
                </span>
              </div>
              <v-simple-table dense>
                <tbody>
                  <tr
                    v-for="payment in allPayments"
                    :key="payment.key"
                  >
                    <td>
                      {{ methodLabel(payment.method) }}
                      <v-chip
                        x-small
                        label
                        class="ml-1"
                      >
                        {{ payment.kind === 'saved' ? 'Adiantamento' : 'Lançado agora' }}
                      </v-chip>
                    </td>
                    <td class="text-right">
                      R$ {{ money(payment.value) }}
                    </td>
                    <td
                      class="text-right"
                      style="width: 220px;"
                    >
                      <v-btn-toggle
                        v-model="destinations[payment.key]"
                        mandatory
                        dense
                        color="primary"
                      >
                        <v-btn
                          small
                          value="master"
                        >
                          Master
                        </v-btn>
                        <v-btn
                          small
                          value="outstanding"
                          :disabled="!hasLeftover"
                        >
                          Avulsa
                        </v-btn>
                      </v-btn-toggle>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </template>
          </v-tab-item>

          <v-tab-item>
            <div class="d-flex justify-space-between text-body-2">
              <span>Itens da avulsa</span><span>R$ {{ money(leftoverItems) }}</span>
            </div>
            <div class="d-flex justify-space-between text-body-2">
              <span>Pagamentos já destinados a ela</span><span>- R$ {{ money(leftoverPaid) }}</span>
            </div>
            <v-divider class="my-1" />
            <div
              class="d-flex justify-space-between font-weight-bold mb-3"
              :class="leftoverBalance < -0.009 ? 'error--text' : ''"
            >
              <span>A receber</span><span>R$ {{ money(leftoverBalance) }}</span>
            </div>

            <v-switch
              v-model="closeLeftover"
              hide-details
              dense
              class="mt-0"
              :label="closeLeftover ? 'Pagar e fechar a avulsa agora' : 'Deixar a avulsa aberta'"
            />
            <div
              v-if="closeLeftover"
              class="mt-3"
            >
              <v-alert
                v-if="leftoverBalance <= 0.009"
                dense
                text
                type="success"
                class="mb-0"
              >
                Os pagamentos escolhidos já cobrem a avulsa. Ela fecha sem novo pagamento.
              </v-alert>
              <template v-else>
                <v-row
                  v-for="(row, index) in leftoverPayments"
                  :key="index"
                  dense
                  align="center"
                >
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-select
                      v-model="row.method"
                      :items="leftoverMethods"
                      label="Forma de pagamento"
                      outlined
                      dense
                      hide-details
                    />
                  </v-col>
                  <v-col
                    cols="9"
                    sm="4"
                  >
                    <v-text-field
                      v-model="row.value"
                      type="number"
                      min="0"
                      step="0.01"
                      :label="index === 0 ? 'Valor (vazio = restante)' : 'Valor'"
                      prefix="R$"
                      outlined
                      dense
                      hide-details
                    />
                  </v-col>
                  <v-col
                    cols="3"
                    sm="2"
                  >
                    <v-btn
                      v-if="leftoverPayments.length > 1"
                      icon
                      small
                      @click="leftoverPayments.splice(index, 1)"
                    >
                      <v-icon small>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col
                    v-if="row.method === 'pix'"
                    cols="12"
                  >
                    <SelectPix
                      v-model="row.pix_id"
                      :error_messages="row.pix_id ? '' : 'Chave Pix é obrigatória'"
                    />
                  </v-col>
                  <v-col
                    v-if="['credit_card', 'debit_card', 'other'].includes(row.method)"
                    cols="12"
                  >
                    <v-text-field
                      v-model="row.code_operation"
                      :label="['credit_card', 'debit_card'].includes(row.method) ? 'Código de autorização' : 'Código da operação'"
                      outlined
                      dense
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-btn
                  text
                  small
                  color="primary"
                  @click="leftoverPayments.push(newLeftoverPayment())"
                >
                  Dividir em outra forma
                </v-btn>
              </template>
              <div class="text-subtitle-2 mt-3">
                Hóspede / empresa da nota da avulsa
              </div>
              <v-radio-group
                v-model="fiscalType"
                row
                dense
                hide-details
                class="mt-1 mb-2"
                @change="fiscalPerson = null"
              >
                <v-radio
                  label="Pessoa física"
                  value="PF"
                />
                <v-radio
                  label="Pessoa jurídica"
                  value="PJ"
                />
              </v-radio-group>
              <AutocompleteSearchGuest
                v-if="fiscalType === 'PF'"
                v-model="fiscalPerson"
                dense
              />
              <AutocompleteSearchCompany
                v-else
                v-model="fiscalPerson"
                dense
              />
              <div class="text-caption">
                Sem escolha, usa a pessoa da nota definida na tela de checkout.
              </div>
              <div class="text-caption mt-2">
                A avulsa fecha como checkout individual e vai para o Gestão na auditoria, separada da master.
              </div>
            </div>
            <div
              v-else
              class="text-caption mt-2"
            >
              A avulsa fica aberta no quarto e pode ser paga depois pela tela de contas avulsas.
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-divider />
      <div class="px-4 py-2 grey lighten-5">
        <v-row
          dense
          align="center"
        >
          <v-col
            cols="12"
            sm="6"
          >
            <div class="text-overline">
              Master
            </div>
            <div class="text-body-2">
              Itens R$ {{ money(masterItems) }} · Pago R$ {{ money(masterPaid) }}
            </div>
            <b :class="masterBalance < -0.009 ? 'error--text' : ''">
              Saldo R$ {{ money(masterBalance) }}
            </b>
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <div class="text-overline">
              Avulsa
            </div>
            <template v-if="hasLeftover">
              <div class="text-body-2">
                Itens R$ {{ money(leftoverItems) }} · Pago R$ {{ money(leftoverPaid) }}
              </div>
              <b :class="leftoverBalance < -0.009 ? 'error--text' : ''">
                A receber R$ {{ money(leftoverBalance) }}
              </b>
            </template>
            <div
              v-else
              class="text-body-2"
            >
              Não haverá conta avulsa
            </div>
          </v-col>
        </v-row>
        <v-alert
          v-if="blockedReason"
          dense
          outlined
          type="warning"
          class="mt-2 mb-0"
        >
          {{ blockedReason }}
        </v-alert>
        <div class="text-caption mt-1">
          Valores sem ISS. O ISS segue cada item.
        </div>
      </div>

      <v-card-actions class="px-4 py-3">
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="$emit('input', false)"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!!blockedReason"
          @click="confirm"
        >
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SelectPix from '@/components/SelectPix.vue'
import AutocompleteSearchGuest from '@/components/AutocompleteSearchGuest.vue'
import AutocompleteSearchCompany from '@/components/AutocompleteSearchCompany.vue'

const LODGING = ['accommodation']
const LODGING_EXTRAS = ['accommodation', 'extra_tarif', 'accommodation_extra_item', 'product', 'service']
const LEFTOVER_METHODS = ['money', 'pix', 'credit_card', 'debit_card', 'other']
const METHODS = {
  money: 'Dinheiro',
  pix: 'PIX',
  credit_card: 'Cartão de crédito',
  debit_card: 'Cartão de débito',
  invoice: 'Faturado',
  b2b: 'B2B',
  transfer: 'Transferência',
  other: 'Outro',
}

export default {
  name: 'GroupTransferDialog',
  components: {
    SelectPix,
    AutocompleteSearchGuest,
    AutocompleteSearchCompany,
  },
  props: {
    value: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },

    // Advance payments already saved for the stay.
    payments: { type: Array, default: () => [] },

    // Payments typed on the checkout screen and not saved yet.
    newPayments: { type: Array, default: () => [] },
    coverageMode: { type: String, default: 'lodging' },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    tab: 0,
    search: '',
    itemsTab: 0,
    selected: [],
    destinations: {},
    closeLeftover: false,
    leftoverPayments: [{
      method: 'money', value: null, pix_id: null, code_operation: '',
    }],
    fiscalType: 'PF',
    fiscalPerson: null,
  }),
  computed: {
    coverageLabel() {
      return this.coverageMode === 'lodging_extras'
        ? 'A master cobre hospedagem + extras (hospedagem e consumo)'
        : 'A master cobre a hospedagem'
    },
    leftoverMethods() {
      return LEFTOVER_METHODS.map(value => ({ value, text: METHODS[value] }))
    },
    allPayments() {
      const saved = this.payments.map(payment => ({
        key: `saved:${payment.id}`,
        kind: 'saved',
        id: payment.id,
        method: payment.method,
        value: Number(payment.value),
      }))
      const typed = this.newPayments.map((payment, index) => ({
        key: `new:${index}`,
        kind: 'new',
        index,
        method: payment.method,
        value: Number(payment.value),
      }))

      return saved.concat(typed)
    },
    groups() {
      return [
        { key: 'daily', label: 'Diárias', origins: ['accommodation'] },
        { key: 'extra', label: 'Extras de tarifa', origins: ['extra_tarif', 'accommodation_extra_item'] },
        { key: 'product', label: 'Consumo (produtos)', origins: ['product'] },
        { key: 'service', label: 'Serviços', origins: ['service'] },
      ].map(group => ({ ...group, items: this.items.filter(item => group.origins.includes(item.origin)) }))
    },
    visibleGroups() {
      const term = (this.search || '').trim().toLowerCase()

      return this.groups
        .filter(group => group.items.length)
        .map(group => ({
          ...group,
          visible: term ? group.items.filter(item => (item.description || group.label).toLowerCase().includes(term)) : group.items,
        }))
        .filter(group => group.visible.length || !term)
    },
    currentGroup() {
      return this.visibleGroups[this.itemsTab] || this.visibleGroups[0] || null
    },
    selectedItems() {
      return this.items.filter(item => this.selected.includes(this.itemKey(item)))
    },
    hasLeftover() {
      return this.selectedItems.length < this.items.length
    },
    masterItems() {
      return this.selectedItems.reduce((sum, item) => sum + item.sale_price * item.pivot.quantity, 0)
    },
    leftoverItems() {
      const all = this.items.reduce((sum, item) => sum + item.sale_price * item.pivot.quantity, 0)

      return all - this.masterItems
    },
    masterPaid() {
      return this.sumPayments('master')
    },
    leftoverPaid() {
      return this.sumPayments('outstanding')
    },
    masterBalance() {
      return this.masterItems - this.masterPaid
    },
    leftoverBalance() {
      return this.leftoverItems - this.leftoverPaid
    },
    confirmLabel() {
      if (this.hasLeftover && this.closeLeftover) return 'Enviar para a master e fechar a avulsa'

      return 'Confirmar envio'
    },
    blockedReason() {
      if (!this.selectedItems.length) return 'Selecione ao menos um item para a conta master.'
      if (this.hasLeftover && this.masterBalance < -0.009) return 'Os pagamentos da master superam os itens enviados.'
      if (this.hasLeftover && this.leftoverBalance < -0.009) return 'Os pagamentos da avulsa superam o saldo avulso.'
      if (this.closeLeftover && this.hasLeftover && this.leftoverBalance > 0.009) {
        const blank = this.leftoverPayments.filter(row => row.value === null || row.value === '')
        if (this.leftoverPayments.some(row => row.method === 'pix' && !row.pix_id)) return 'Informe a chave Pix do pagamento da avulsa.'
        if (this.leftoverPayments.some(row => ['credit_card', 'debit_card'].includes(row.method) && !String(row.code_operation || '').trim())) {
          return 'Informe o código de autorização do cartão da avulsa.'
        }
        if (blank.length > 1) return 'Informe o valor de cada forma de pagamento da avulsa, exceto uma.'
        if (!blank.length) {
          const paid = this.leftoverPayments.reduce((sum, row) => sum + Number(row.value), 0)
          if (Math.abs(paid - this.leftoverBalance) > 0.01) return 'O pagamento da avulsa deve ser igual ao que falta receber (sem ISS).'
        }
      }

      return ''
    },
  },
  watch: {
    value(open) {
      if (open) this.reset()
    },
  },
  methods: {
    sumPayments(target) {
      return this.allPayments
        .filter(payment => this.destinationOf(payment) === target)
        .reduce((sum, payment) => sum + payment.value, 0)
    },
    itemKey(item) {
      return `${item.origin}:${item.id}:${item.pivot.pdv_id || ''}`
    },
    destinationOf(payment) {
      const destination = this.destinations[payment.key] || 'master'

      return destination === 'outstanding' && this.hasLeftover ? 'outstanding' : 'master'
    },
    applyCoverage() {
      const origins = this.coverageMode === 'lodging_extras' ? LODGING_EXTRAS : LODGING
      this.selected = this.items.filter(item => origins.includes(item.origin)).map(this.itemKey)
    },
    selectAll() {
      this.selected = this.items.map(this.itemKey)
    },
    reset() {
      this.applyCoverage()
      const destinations = {}
      this.allPayments.forEach(payment => {
        const corporate = ['invoice', 'b2b'].includes(payment.method)
        destinations[payment.key] = corporate ? 'master' : 'outstanding'
      })
      this.destinations = destinations
      this.search = ''
      this.itemsTab = 0
      this.closeLeftover = false
      this.leftoverPayments = [this.newLeftoverPayment()]
      this.fiscalType = 'PF'
      this.fiscalPerson = null
      this.tab = 0
    },
    groupState(group) {
      const keys = group.items.map(this.itemKey)
      const count = keys.filter(key => this.selected.includes(key)).length

      return { all: keys.length > 0 && count === keys.length, some: count > 0 && count < keys.length, count }
    },
    groupSelectedTotal(group) {
      return group.items
        .filter(item => this.selected.includes(this.itemKey(item)))
        .reduce((sum, item) => sum + item.sale_price * item.pivot.quantity, 0)
    },
    groupTotal(group) {
      return group.items.reduce((sum, item) => sum + item.sale_price * item.pivot.quantity, 0)
    },
    toggleGroup(group, checked) {
      const keys = (group.visible || group.items).map(this.itemKey)
      const rest = this.selected.filter(key => !keys.includes(key))
      this.selected = checked ? rest.concat(keys) : rest
    },
    newLeftoverPayment() {
      return {
        method: 'money', value: null, pix_id: null, code_operation: '',
      }
    },
    methodLabel(method) {
      return METHODS[method] || method
    },
    money(value) {
      const number = Math.abs(Number(value || 0)) < 0.005 ? 0 : Number(value || 0)

      return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    confirm() {
      const saved = this.allPayments.filter(payment => payment.kind === 'saved')
      const typed = this.allPayments.filter(payment => payment.kind === 'new')

      this.$emit('confirm', {
        checkout: this.selectedItems,
        advance_payments: saved.map(payment => ({
          payment_item_id: payment.id,
          destination: this.destinationOf(payment),
        })),
        new_payment_destinations: typed.map(payment => this.destinationOf(payment)),
        leftover_checkout: this.closeLeftover && this.hasLeftover
          ? {
            paymentMethods: this.leftoverBalance > 0.009
              ? this.leftoverPayments.map(row => ({
                method: row.method,
                value: row.value === null || row.value === '' ? null : Number(row.value),
                pix_id: row.method === 'pix' ? row.pix_id : undefined,
                code_operation: row.code_operation || undefined,
              }))
              : [],
            dataNotaFiscal: this.fiscalPerson && this.fiscalPerson.id
              ? { type_of_person: this.fiscalType, id: this.fiscalPerson.id, no_show: false }
              : undefined,
          }
          : undefined,
      })
    },
  },
}
</script>

<style scoped>
.item-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
